import React from 'react';
import styled from 'styled-components';
import SocialIconSvg from '../../stories/assets/social.svg';

const SocialIcon = styled(SocialIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || 'black'};
  margin: ${props => props.margin};
  cursor: pointer;
  transform: ${props => props.transform || 'scale(1)'};
`;

export default SocialIcon;
